import { render } from "./PageHeaderBanner.vue?vue&type=template&id=5cfb3e9a&scoped=true"
const script = {}

import "./PageHeaderBanner.vue?vue&type=style&index=0&id=5cfb3e9a&scoped=true&lang=css"

import exportComponent from "C:\\atto\\atto-chempanda\\chempanda\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cfb3e9a"]])

export default __exports__